// The Item upsert replaces the whole row instead of patching it, so the edit
// form must round-trip every server field — including the ones it does not
// render. Hand-seeding the form is exactly how `calories` and `showcalories`
// got wiped on unrelated edits; keeping the shape in one tested function is
// what stops the next field added to Item from repeating it.
export const emptyItemForm = (productid, displayorder, name = '') => ({
  id: '',
  productid,
  name,
  price: null,
  displayorder,
  calories: '',
  // Off by default: calories are opt-in per restaurant. Existing items keep
  // their stored value (see itemFormFromItem); only new items start hidden.
  showcalories: false,
  squareid: '',
  squarename: '',
  usesquareprice: false,
  squaremissing: false,
});

export const itemFormFromItem = (item, productid) => ({
  id: item.id,
  productid,
  name: item.name,
  price: item.price,
  displayorder: item.displayorder,
  // `?? ''` not `|| ''`: calories of 0 is a real value (Water = 0 cal).
  calories: item.calories ?? '',
  showcalories: item.showcalories ?? true,
  squareid: item.squareid ?? '',
  squarename: item.squarename ?? '',
  usesquareprice: item.usesquareprice ?? false,
  squaremissing: item.squaremissing ?? false,
});
